// The learner's modes, one list for everything that shows them (job #340).
// The selector tray and the green where-am-I badge both read their names from
// here and their icons from ModeIcon.vue, so the two can never drift apart.
import { isBuildMode } from '../script/modeName'

export type Mode = 'speaking' | 'listening' | 'talk' | 'studyGroups' | 'script'

// Listening's name is settings.listeningMode, NOT modes.listening: the settings
// key is the one translated in every locale.
export const MODE_NAME_KEY: Record<Mode, string> = {
  speaking: 'modes.speaking',
  listening: 'settings.listeningMode',
  talk: 'modes.talkToHumans',
  studyGroups: 'modes.studyGroups',
  script: 'modes.script',
}

/**
 * The name key for a mode on a given course. Script mode is called Build where
 * the card taps LEGO tiles into order (script/modeName.ts); every other mode is
 * the same on every course.
 */
export function modeNameKey(mode: Mode, courseCode?: string | null): string {
  if (mode === 'script' && courseCode && isBuildMode(courseCode)) return 'modes.build'
  return MODE_NAME_KEY[mode]
}
